import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { buttonBaseVariants } from "@/v2-ui/button/base/button.base.constants"
import { AlertDialogCancel as AlertDialogCancelBase } from "./base/AlertDialogBase"

export type AlertDialogCancelProps = ComponentProps<
  typeof AlertDialogCancelBase
>

function AlertDialogCancel(props: AlertDialogCancelProps) {
  const { className, ...alertDialogCancelBaseProps } = props
  return (
    <AlertDialogCancelBase
      className={cn(
        "ui-alert-dialog-cancel",
        buttonBaseVariants({ variant: "secondary", className }),
      )}
      {...alertDialogCancelBaseProps}
    />
  )
}

export default AlertDialogCancel
